import React, { Component } from "react";
import { NPS_URL } from ".";
import { RequestModes } from "../mailBackRequest/investor";

export default class mis extends Component {
  render() {
    return (
      <div className="mail-back-investor-modes-container">
        <div className="investor-title ">MIS Reports</div>
        <div className="flex" style={{ flexWrap: "wrap" }}>
          <RequestModes
            name="Pending PRANs"
            image="/images/swf.svg"
            onClick={() =>
              this.props.history.push(NPS_URL + "/mis/reports", { type: "P" })
            }
          />
          <RequestModes
            name="Completed PRANs"
            image="/images/redemption.svg"
            onClick={() =>
              this.props.history.push(NPS_URL + "/mis/reports", {
                type: "CM",
              })
            }
          />
          <RequestModes
            name="Contributions"
            image="/images/nach.svg"
            onClick={() =>
              this.props.history.push(NPS_URL + "/mis/reports", {
                type: "CN",
              })
            }
          />
        </div>
      </div>
    );
  }
}
